import { rawCanvas } from "./canvas";
import {
  ASSET_TOKENS,
  PixelAsset,
  decodePixels,
} from "../../common/src/pixel-assets";
import { K } from "./hd-kit";

export const assetColor = (index: number): string =>
  index === 0 ? "transparent" : K[ASSET_TOKENS[index] as keyof typeof K];

/** The asset on its whole canvas (asset.width x asset.height), as the Asset Studio edits it. */
export function paintPixelAsset(asset: PixelAsset): HTMLCanvasElement {
  const cv = rawCanvas(asset.width, asset.height);
  const g = cv.getContext("2d")!,
    pixels = decodePixels(asset);
  for (let i = 0; i < pixels.length; i++)
    if (pixels[i]) {
      g.fillStyle = assetColor(pixels[i]);
      g.fillRect(i % asset.width, Math.floor(i / asset.width), 1, 1);
    }
  return cv;
}

/** The asset cropped to its drawn pixels, optionally mirrored or turned 180 degrees about its foot anchor.
 *  `ax, ay` is the anchor inside the returned canvas (it can sit just outside it). One art px = one hd px. */
export function paintPixelSprite(
  asset: PixelAsset,
  flip = false,
  rotation: 0 | 180 = 0,
) {
  const [x0, y0, w, h] = asset.box,
    full = paintPixelAsset(asset),
    cv = rawCanvas(w, h);
  const g = cv.getContext("2d")!;
  // Mirroring flips x; a half turn flips x and y. Both about the crop's center, and the anchor flips with them.
  const sx = flip !== (rotation === 180) ? -1 : 1,
    sy = rotation === 180 ? -1 : 1;
  g.translate(sx < 0 ? w : 0, sy < 0 ? h : 0);
  g.scale(sx, sy);
  g.drawImage(full, x0, y0, w, h, 0, 0, w, h);
  const ax = asset.ax - x0,
    ay = asset.ay - y0;
  return {
    canvas: cv,
    ax: sx < 0 ? w - ax : ax,
    ay: sy < 0 ? h - ay : ay,
  };
}
